/* 专家端专属 state getter */
export const courseList = state => state.courseList;
export const currentPictures = state => state.materialPictureList;
export const hasPictures = state => state.hasPictures;
export const hasPPTs = state => state.hasPPTs;
export const currentAudios = state => state.materialaAudioList;
export const currentVideos = state => state.materialaVideoList;
export const materialPPTList = state => state.materialPPTList;

export const replyMessage = state => state.replyMessage;
export const audio = state => state.audio;
export const livePopupVisible = state => state.livePopupVisible;
export const expertInfo = state => state.expertInfo;
export const liveBarActive = state => state.isActive;
export const issues = state => state.issues;
export const sendImageLocalIds = state => state.sendImageLocalIds;
export const courseUpCount = state => state.courseUpCount;
export const firstAjaxStatus = state => state.firstAjaxStatus;
export const slides = state => state.slides;
export const courseRecommends = state => state.courseRecommends;
export const replayMessageIds = state => state.replayMessageIds;
export const mediaId = state => state.mediaId;
export const isUpdateVideo = state => state.isUpdateVideo;
export const courseMsgList = state => state.courseMsgList;
export const guestbookList = state => state.guestbookList;
export const weeks = state => state.weeks;
export const imMsgInfo = state => state.imMsgInfo; // 已完成订单IM消息



// WEBPACK FOOTER //
// ./src/store/expert/getters.expert.js